var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEntroGeocerca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#106610;}.cls-3{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-entro-geocerca") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_29",
    "data-name": 29
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.71,172.28Q149.31,155.6,170,139c1-.77,1.88-1.58,2.79-2.35-4.41-2.58-8.84-1.84-13.29-1.15-2.54.4-12.29,1.29-12.29,1.29l3.08-3s11.09-1.15,14.14-1.58a3.72,3.72,0,0,1,2.79-3.82,33,33,0,0,1,6.86-1.92,31.77,31.77,0,0,1,15.16,1c1.86.64,3.44,2.07,5.15,3.15v1.59c-2.43,3.28-6.15,3.71-9.73,4.29-2.08.34-4.25.16-6.35.42a5.56,5.56,0,0,0-3,1.12Q156,156.08,136.87,174.25c-.28.26-.54.56-1,1l2,1.34c2.79,2,2.94,4.53-.06,6.11a31.41,31.41,0,0,1-8.56,3,41.93,41.93,0,0,1-19.72-.84,19.29,19.29,0,0,1-3.34-1.27c-3.77-1.87-4.21-3.59-1.78-7.06-.56-.34-1.1-.7-1.66-1-13.58-7.39-27.16-14.8-40.77-22.12a5.79,5.79,0,0,0-3.34-.52c-6,.84-12.09,1.08-17.95-.84-2.09-.68-3.88-2.31-5.81-3.52v-2c3.94-3.92,9.07-4.39,14.16-4.68,5.47-.3,10.88.21,15.92,2.71a3.41,3.41,0,0,0,1.72.1c8.91-1,32.14-3.75,32.14-3.75l2.16,2.29s-24.74,3-32,3.78a2.26,2.26,0,0,0-2,1.49c-.67,1.26-2.06,2.13-3.26,3.27.35.2.82.52,1.32.75,14.62,6.63,29.28,13.17,43.83,20C111.93,173.89,127.45,173.3,128.71,172.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.4,62.74v61.14H148l-27,27.84L94,123.88h11.6V62.74H136.4m6.69-6.68H98.94v61.13H78.24L121,161.33l42.77-44.14H143.09V56.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEntroGeocerca);
export default __webpack_public_path__ + "static/media/ic-entro-geocerca.35e807e862429dbe891fe1c39b36cada.svg";
export { ForwardRef as ReactComponent };